import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-mb-icon',
  imports: [NzIconModule],
  templateUrl: './mb-icon.component.html',
})
export class MbIconComponent {
  @Input() type = '';
  @Input() variant: 'black' | 'gray' = 'black';

  get iconColor(): string {
    return this.variant === 'gray' ? 'var(--color-mbaza-gray)' : 'black';
  }
}
